import { createSettingsParams } from '@wix/tpa-settings';

import {
  displaySettingsParams,
  DisplaySettingsParams,
} from './Settings/Tabs/Display/settingsParams';
import {
  layoutSettingsParams,
  LayoutSettingsParams,
} from './Settings/Tabs/Layout/settingsParams';
import {
  menusSettingsParams,
  MenusSettingsParams,
} from './Settings/Tabs/Menus/settingsParams';
import {
  settingsTabParams,
  SettingsTabParams,
} from './Settings/Tabs/SettingsTab/settingsParams';
import {
  textSettingsParams,
  TextSettingsParams,
} from './Settings/Tabs/Text/settingsParams';

export type SettingsParams = DisplaySettingsParams &
  LayoutSettingsParams &
  MenusSettingsParams &
  SettingsTabParams &
  TextSettingsParams;

// Only params listed here reach the widget's editor manifest (and Aria).
export default createSettingsParams<SettingsParams>({
  ...displaySettingsParams,
  ...layoutSettingsParams,
  ...menusSettingsParams,
  ...settingsTabParams,
  ...textSettingsParams,
});
